import React, { Component } from "react";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import * as firebase from "firebase/app";
import { withFirebase } from "../Firebase";
import "filepond/dist/filepond.min.css";
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginFileValidateType
);
//https://www.npmjs.com/package/url-metadata
//update code to make it compatible with different cases one/multi image upload
class ImageUpload extends Component {
  constructor(props) {
    super(props);
    console.log(this.props.imageProps);
    this.state = {
      files:
        this.props.imageProps === "N/A" || this.props.imageProps === ""
          ? []
          : [
              {
                source: this.props.imageProps.imageUrl,
                options: {
                  type: "local",
                  file: {
                    name: this.props.imageProps.imageName,
                    size: this.props.imageProps.imageSize,
                    type: this.props.imageProps.imageType
                  }
                }
              }
            ],
      fileUrl: "",
      fileSize: 0,
      fileName:
        this.props.imageProps.imageName === undefined
          ? this.props.imageProps.imageName
          : "",
      fileType: ""
    };
  }
  componentDidCatch() {
    //checks weather a file exists
  }
  server = url => {
    return {
      process: (fieldName, file, metadata, load, error, progress, abort) => {
        // upload the image to firebase

        const task = this.props.firebase
          .storageRef()
          .child(url + file.name)
          .put(file, {
            contentType: file.type,
            size: file.size
          });

        // monitor the task to provide updates to FilePond
        task.on(
          firebase.storage.TaskEvent.STATE_CHANGED,
          snapshot => {
            // provide progress updates
            progress(true, snapshot.bytesTransferred, snapshot.totalBytes);
          },
          err => {
            // provide errors
            error(err.message);
            abort();
          },
          () => {
            // the file has been uploaded
            console.log("DONE");

            task.snapshot.ref.getDownloadURL().then(downloadURL => {
              this.setState({
                fileUrl: downloadURL,
                fileName: file.name,
                fileSize: file.size,
                fileType: file.type
              });
              this.callBackFunction();
            });

            load(file);
          }
        );
      },
      load: (source, load, error, progress, abort) => {
        // reset our progress
        progress(true, 0, 1024);

        console.log("source:  " + source);
        // fetch the download URL from firebase
        this.props.firebase
          .storageRef()
          .child(url + source.name)
          .getDownloadURL()
          .then(url => {
            // fetch the actual image using the download URL
            // and provide the blob to FilePond using the load callback
            let xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = function(event) {
              let blob = xhr.response;
              load(blob);
            };
            console.log(url);
            this.setState({
              fileUrl: url,
              fileName: source.name,
              fileSize: source.size,
              fileType: source.type
            });
            xhr.open("GET", url);
            xhr.send();
          })
          .catch(err => {
            error(err.message);
            abort();
          });
      }
    };
  };
  handleRemove = (url, id) => (error, file) => {
    this.props.firebase
      .storageRef()
      .child(url + this.state.fileName)
      .delete()
      .then(() => {
        console.log(" File deleted successfully");
        this.setState({
          fileUrl: "",
          fileSize: "",
          fileName: "",
          fileType: ""
        });
        if (id !== "") {
          this.props.firebase.event(id).update({
            imageProps: ""
          });
        }

        this.callBackFunction();
      })
      .catch(err => {
        console.log(err);
        console.log("Uh-oh, an error occurred!");
      });
  };

  callBackFunction = () => {
    this.props.setImageProps(
      this.state.fileUrl,
      this.state.fileName,
      this.state.fileSize,
      this.state.fileType
    );
  };
  render() {
    const { id, url } = this.props;
    return (
      <FilePond
        files={this.state.files}
        allowMultiple={this.props.allowMultiple}
        maxFiles={1}
        acceptedFileTypes="image/*"
        onupdatefiles={fileItems => {
          if (fileItems.length === 0) {
            console.log("deleting items");
            this.handleRemove(id, url);
          }
          this.setState({
            files: fileItems.map(fileItem => fileItem.file)
          });
        }}
        onremovefile={this.handleRemove(id, url)}
        server={this.server(url)}
      />
    );
  }
}
export default withFirebase(ImageUpload);
